var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _rect2, _path27, _path28, _rect3, _path29, _path30, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9 107.4C83.6 107.4 107.8 83.3003 107.8 53.7003C107.8 24.0003 83.7 0.000311368 53.9 0.000311368C24.1 -0.0996886 0 23.9003 0 53.6003C0 83.3003 24.1 107.4 53.9 107.4Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7237 106.51H10.2755V29.5275C10.2755 28.6229 11.009 27.8895 11.9135 27.8895H97.0857C97.9902 27.8895 98.7237 28.6229 98.7237 29.5275V106.51Z",
    fill: "url(#paint0_linear_12512_8965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7248 53.955C98.3892 54.0385 98.0439 54.096 97.6824 54.096C95.2976 54.096 93.3642 52.1626 93.3642 49.7778C93.3642 52.1624 91.4308 54.096 89.046 54.096C86.6611 54.096 84.7277 52.1626 84.7277 49.7778C84.7277 52.1624 82.7945 54.096 80.4095 54.096C78.0247 54.096 76.0913 52.1626 76.0913 49.7778C76.0913 52.1624 74.1579 54.096 71.7731 54.096C69.3882 54.096 67.4549 52.1626 67.4549 49.7778C67.4549 52.1624 65.5215 54.096 63.1366 54.096C60.7518 54.096 58.8184 52.1626 58.8184 49.7778C58.8184 52.1624 56.8852 54.096 54.5002 54.096C52.1152 54.096 50.182 52.1626 50.182 49.7778C50.182 52.1624 48.2486 54.096 45.8637 54.096C43.4789 54.096 41.5455 52.1626 41.5455 49.7778C41.5455 52.1624 39.6123 54.096 37.2273 54.096C34.8425 54.096 32.9091 52.1626 32.9091 49.7778C32.9091 52.1624 30.9757 54.096 28.5908 54.096C26.206 54.096 24.2726 52.1626 24.2726 49.7778C24.2726 52.1624 22.3392 54.096 19.9544 54.096C17.5696 54.096 15.6362 52.1626 15.6362 49.7778C15.6362 52.1624 13.703 54.096 11.3179 54.096C10.9565 54.096 10.6112 54.0385 10.2755 53.955V57.2666C10.6195 57.3143 10.961 57.372 11.3179 57.372C12.9209 57.372 14.4093 56.8729 15.6362 56.0218C16.8634 56.8727 18.3516 57.3718 19.9548 57.3718C21.5577 57.3718 23.0462 56.8727 24.273 56.0216C25.4998 56.8727 26.9883 57.3718 28.5912 57.3718C30.1941 57.3718 31.6826 56.8727 32.9094 56.0216C34.1363 56.8727 35.6247 57.3718 37.2277 57.3718C38.8306 57.3718 40.319 56.8727 41.5459 56.0216C42.7727 56.8727 44.2612 57.3718 45.8641 57.3718C47.467 57.3718 48.9555 56.8727 50.1823 56.0216C51.409 56.8727 52.8974 57.3718 54.5004 57.3718C56.1033 57.3718 57.5918 56.8727 58.8186 56.0216C60.0454 56.8727 61.5339 57.3718 63.1368 57.3718C64.7397 57.3718 66.2282 56.8727 67.455 56.0216C68.6819 56.8727 70.1703 57.3718 71.7733 57.3718C73.3762 57.3718 74.8647 56.8727 76.0915 56.0216C77.3183 56.8727 78.8068 57.3718 80.4097 57.3718C82.0126 57.3718 83.5011 56.8727 84.7279 56.0216C85.9548 56.8727 87.4432 57.3718 89.0462 57.3718C90.6493 57.3718 92.1375 56.8727 93.3644 56.0216C94.5912 56.8727 96.0797 57.3718 97.6826 57.3718C98.0394 57.3718 98.381 57.3143 98.725 57.2665V53.955H98.7248Z",
    fill: "#5B5D6E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.466,
    y: 60.6489,
    width: 45.8619,
    height: 29.4828,
    fill: "#ECF0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8642 54.0962C43.4794 54.0962 41.546 52.1628 41.546 49.778V45.9066H50.1825V49.778C50.1825 52.1628 48.2491 54.0962 45.8642 54.0962Z",
    fill: "#979FAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1374 54.0962C60.7526 54.0962 58.8192 52.1628 58.8192 49.778V45.9066H67.4557V49.778C67.4555 52.1628 65.5223 54.0962 63.1374 54.0962Z",
    fill: "#979FAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5907 54.0962C26.2059 54.0962 24.2725 52.1628 24.2725 49.778V45.9066H32.9089V49.778C32.9087 52.1628 30.9755 54.0962 28.5907 54.0962Z",
    fill: "#979FAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3182 54.0964C8.93339 54.0964 7 52.163 7 49.7782V45.9067H15.6364V49.7782C15.6364 52.163 13.7031 54.0964 11.3182 54.0964Z",
    fill: "#979FAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4099 54.0962C78.0251 54.0962 76.0917 52.1628 76.0917 49.778V45.9066H84.7281V49.778C84.7281 52.1628 82.7949 54.0962 80.4099 54.0962Z",
    fill: "#979FAF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2282 54.0964C34.8434 54.0964 32.91 52.163 32.91 49.7782V45.9067H41.5464V49.7782C41.5464 52.163 39.6132 54.0964 37.2282 54.0964Z",
    fill: "#C7CFE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7722 54.0962C69.3874 54.0962 67.454 52.1628 67.454 49.778V45.9066H76.0905V49.778C76.0903 52.1628 74.1571 54.0962 71.7722 54.0962Z",
    fill: "#C7CFE2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6802 54.097C95.2954 54.097 93.362 52.1636 93.362 49.7787V45.9073H101.998V49.7787C101.998 52.1636 100.065 54.097 97.6802 54.097Z",
    fill: "#979FAF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0446 54.0962C86.6598 54.0962 84.7264 52.1628 84.7264 49.778V45.9066H93.3628V49.778C93.3626 52.1628 91.4292 54.0962 89.0446 54.0962Z",
    fill: "#C7CFE2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 54.0964C17.5702 54.0964 15.6368 52.163 15.6368 49.7782V45.9067H24.2732V49.7782C24.2732 52.163 22.3398 54.0964 19.955 54.0964Z",
    fill: "#C7CFE2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5007 54.0962C52.1159 54.0962 50.1825 52.1628 50.1825 49.778V45.9066H58.8189V49.778C58.8189 52.1628 56.8855 54.0962 54.5007 54.0962Z",
    fill: "#C7CFE2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1823 45.9071H41.546L42.4394 32.8036H50.4803L50.1823 45.9071Z",
    fill: "#A1ABBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4551 45.9071H58.8188L58.5208 32.8036H66.5617L67.4551 45.9071Z",
    fill: "#A1ABBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9087 45.9071H24.2725L26.3571 32.8036H34.3977L32.9087 45.9071Z",
    fill: "#A1ABBD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 45.9074H7L10.2758 32.804H18.3167L15.6364 45.9074Z",
    fill: "#A1ABBD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.728 45.9071H76.0916L74.6028 32.8036H82.6432L84.728 45.9071Z",
    fill: "#A1ABBD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5464 45.9074H32.91L34.399 32.804H42.4398L41.5464 45.9074Z",
    fill: "#EFF2FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.09 45.9071H67.4538L66.5604 32.8036H74.6012L76.09 45.9071Z",
    fill: "#EFF2FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.999 45.9075H93.363L90.6828 32.804H98.7237L101.999 45.9075Z",
    fill: "#A1ABBD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3636 45.9071H84.7273L82.6425 32.8036H90.6833L93.3636 45.9071Z",
    fill: "#EFF2FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.273 45.9074H15.6368L18.317 32.804H26.3577L24.273 45.9074Z",
    fill: "#EFF2FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8189 45.9071H50.1825L50.4805 32.8036H58.521L58.8189 45.9071Z",
    fill: "#EFF2FA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M100.362 108.149H8.638C7.73347 108.149 7 107.415 7 106.511C7 105.606 7.73347 104.873 8.638 104.873H100.362C101.267 104.873 102 105.606 102 106.511C102 107.415 101.266 108.149 100.362 108.149Z",
    fill: "#C7CFE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2755,
    y: 101.597,
    width: 88.4482,
    height: 3.27582,
    fill: "#AFB9D2"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2755,
    y: 95.0456,
    width: 88.4482,
    height: 6.55165,
    fill: "#D5DDEA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.465 59.0095H64.3271C65.2316 59.0095 65.9649 59.743 65.9649 60.6475V90.1303C65.9649 91.0348 65.2314 91.7683 64.3269 91.7683H18.465C17.5605 91.7683 16.827 91.0348 16.827 90.1303V60.6475C16.827 59.743 17.5605 59.0095 18.465 59.0095ZM62.6885 88.4928V62.286H20.1024V88.4928H62.6885Z",
    fill: "#A1ABBD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5331 59.0097H74.1538C73.2493 59.0097 72.5158 59.7432 72.5158 60.6477V101.596H92.171V60.6477C92.171 59.7432 91.4377 59.0097 90.5331 59.0097Z",
    fill: "#A1ABBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.7922,
    y: 62.2861,
    width: 13.1035,
    height: 26.2068,
    fill: "#ECF0F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.731 100.447C108.486 101.486 108.118 102.586 107.689 103.503C106.524 105.763 104.685 107.536 102.417 108.697C100.088 109.858 97.3294 110.346 94.5709 109.735C88.0732 108.391 83.9048 102.036 85.2534 95.5587C86.602 89.0814 92.9158 84.865 99.4136 86.2705C101.743 86.7593 103.766 87.9204 105.482 89.5091C108.363 92.3811 109.589 96.5364 108.731 100.447Z",
    fill: "url(#paint1_linear_12512_8965)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100.823 96.9639H98.065V94.2141C98.065 93.6641 97.6359 93.1753 97.0229 93.1753C96.4712 93.1753 95.9808 93.603 95.9808 94.2141V96.9639H93.2223C92.6706 96.9639 92.1802 97.3916 92.1802 98.0027C92.1802 98.6138 92.6093 99.0415 93.2223 99.0415H95.9808V101.791C95.9808 102.341 96.4099 102.83 97.0229 102.83C97.5746 102.83 98.065 102.402 98.065 101.791V99.0415H100.823C101.375 99.0415 101.866 98.6138 101.866 98.0027C101.866 97.3916 101.375 96.9639 100.823 96.9639Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12512_8965",
    x1: 54.4708,
    y1: 26.0709,
    x2: 54.4708,
    y2: 107.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12512_8965",
    x1: 97.0019,
    y1: 86.8337,
    x2: 97.0019,
    y2: 100.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.82e55681.svg";
export { ForwardRef as ReactComponent };